import { z } from 'zod';
import { emptyToNull } from './empty-to-null';

/**
 * Helper function to convert a valid ISO string to a Date object.
 * If the value has already been resolved as null, pass null forward.
 */
const parseDateOrNull = (isoDateString: string | null): Date | null => {
  if (isoDateString === null) {
    return null;
  }
  return new Date(isoDateString);
};

/**
 * Schema to convert ISO-8601 Strings into Date objects.
 *
 * Validation Pipeline:
 * 1. Preprocess (.preprocess): Receives dirty data and applies validators (emptyToNull). If it was "n/a", it becomes null.
 * 2. Validate (.string().datetime().nullable()): Ensures the format and permits the type to be valid or null.
 * 3. Transform (.transform): Transforms the validated string into a Javascript "Date" object.
 */
export const isoDateSchema = z.preprocess(
  emptyToNull,
  z.string().datetime().nullable().transform(parseDateOrNull)
);
